/**
 * @voltxampere/presets — Category metadata
 *
 * Order is the order they appear in the selector left panel.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
export const CATEGORIES = [
    {
        id: "basic",
        name: { tr: "Temel", en: "Basic" },
    },
    {
        id: "filter",
        name: { tr: "Filtre", en: "Filter" },
    },
    {
        id: "amplifier",
        name: { tr: "Yükselteç", en: "Amplifier" },
    },
    {
        id: "digital",
        name: { tr: "Dijital", en: "Digital" },
    },
    {
        id: "power",
        name: { tr: "Güç", en: "Power" },
    },
    // Sprint 50 ADR-0072 — Aşama 4 LANSMAN extensions.
    {
        id: "oscillator",
        name: { tr: "Osilatör", en: "Oscillator" },
    },
    {
        id: "mcu",
        name: { tr: "Mikrodenetleyici", en: "Microcontroller" },
    },
];
const VALID_CATEGORIES = new Set(CATEGORIES.map((c) => c.id));
export function isValidCategory(s) {
    return VALID_CATEGORIES.has(s);
}
//# sourceMappingURL=categories.js.map